import { Add } from "@mui/icons-material";
import { Fab, Portal } from "@mui/material";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

type RegisterFabProps = {
  registerUrl: string;
  isDisabled?: boolean;
  disabledReason?: string;
  label?: string;
}

const RegisterFab: FC<RegisterFabProps> = ({registerUrl, isDisabled = false, disabledReason, label = "Cadastrar"}): JSX.Element => {
  const navigate = useNavigate();

  return (
    <Portal>
      <Fab
        color="primary"
        variant="extended"
        disabled={isDisabled}
        title={isDisabled ? disabledReason : undefined}
        onClick={() => {
          if (isDisabled) return;

          if (window.confirm("Deseja seguir para o cadastro?")) {
            navigate(registerUrl);
          }
        }}
        sx={{
          margin: 0,
          top: 'auto',
          right: 20,
          bottom: 20,
          left: 'auto',
          position: 'fixed',
          borderRadius: '5px',
        }}
      >
        <Add />
        {label}
      </Fab>
    </Portal>
  )
}

export default RegisterFab;
